import { create } from "zustand"

interface CoachSelectStore {
  selectedCoachUserId: number | null
  setSelectedCoachUserId: (coachUserId: number) => void
}

const useCoachSelectStore = create<CoachSelectStore>((set) => ({
  selectedCoachUserId: null,
  setSelectedCoachUserId: (coachUserId: number) =>
    set({ selectedCoachUserId: coachUserId }),
}))

export default useCoachSelectStore
